document.addEventListener("DOMContentLoaded", function () {
  let tabs = document.querySelectorAll(".custom-tab .tab-item");
  let active = 0;
  let sectionAll = document.querySelectorAll(".shopify-section.section");
  let section = [];
  let custom_tab = document.querySelector(".custom-tab");
  const keyword = /featured_collection/;
  const keyword2 = /custom_collection/;

  sectionAll.forEach((element) => {
    if (keyword.test(element.id) || keyword2.test(element.id)) {
      section.push(element);
    }
  });
  tabs.forEach((item, index) => {
    if (section[index]) {
      item.href = `#${section[index].id}`;
    }
    if (index == 0) {
      item.classList.add("tab-item-active");
    }
    item.addEventListener("click", function () {
      item.classList.add("tab-item-active");
      active = index;
      tabs.forEach((items, indexs) => {
        if (indexs != active) {
          items.classList.remove("tab-item-active");
        }
      });
    });
  });
  function setCustomTab() {
    let content = document
      .querySelector(".custom-tab .custom-tab-content")
      .getBoundingClientRect();
    let width = document.documentElement.clientWidth;
    if (content.width > width) {
      document.querySelector(".custom-tab").style.overflowX = "auto";
      document.querySelector(".custom-tab").style.justifyContent = "flex-start";
    } else {
      document.querySelector(".custom-tab").style.justifyContent = "center";
    }
  }
  function setparentNodeTop() {
    let navHeight = document.querySelector(
      "header.header"
    );
    let topNotifications = document.querySelector(
      ".shopify-section.shopify-section-group-header-group.announcement-bar-section"
    );  
    custom_tab.parentNode.style.top = `${
      navHeight.offsetHeight +
      (topNotifications ? topNotifications.offsetHeight : 0)
    }px`;
    custom_tab.parentNode.style.position = "sticky";
    custom_tab.parentNode.style.zIndex = "1";
  }
  setCustomTab()
  setparentNodeTop();
  window.addEventListener("resize", function () {
    setCustomTab()
    setparentNodeTop();
  });
});
